import React from "react"
import Modal from "react-responsive-modal"
import { Image, Box, Flex, Text } from "rebass"
import styled from "styled-components"
import { Button } from "rebass/styled-components"
import { PropTypes } from "prop-types"

import withTranslation from "../i18n/withTranslation"
import logoBalmaceda from "../assets/logoBalmaceda.svg"
import Contact from "./Contact"

const modalStyles = {
  closeButton: {
    background: "white",
    borderRadius: "100%",
    padding: "4px",
  },
  overlay: {
    padding: 0,
  },
  modal: {
    maxWidth: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}

const Item = styled.div`
  display: inline-flex;
  width: 50%;
  padding: 40px 6%;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  button {
    cursor: pointer;
    appearance: none;
    border: none;
    transition: all 0.5s ease;
    background: transparent;

    &:hover {
      opacity: 0.8;
    }
  }
`

class CollectionItem extends React.Component {
  constructor() {
    super()
    this.state = {
      open: false,
      showContact: false,
      openModalImage: false,
    }
  }

  createMarkup = content => {
    return { __html: content }
  }

  onOpenModal = () => {
    this.setState({ open: true })
  }

  onCloseModal = () => {
    this.setState({ open: false })
    this.setState({ showContact: false })
  }

  onOpenImageModal = () => {
    this.setState({ openModalImage: true })
  }

  onCloseImageModal = () => {
    this.setState({ openModalImage: false })
  }

  onOpenContact = () => {
    this.setState({ showContact: true })
  }

  render() {
    const { open, showContact, openModalImage } = this.state
    const {
      title,
      name,
      description,
      thumbImg,
      featuredImg,
      zoomImg,
      t,
      language,
    } = this.props

    return (
      <Item>
        <Flex flexDirection="row">
          <button onClick={this.onOpenModal} type="button">
            <Image
              alt=""
              sx={{
                width: ["100%", "100%"],
              }}
              src={thumbImg}
            />
          </button>
        </Flex>
        <Modal open={open} onClose={this.onCloseModal} center>
          <Flex flexDirection={["column", "row"]} py={3} px={[0, 2, 4]} mt={4}>
            <Box
              width={[1, 1 / 2]}
              px={[0, 2, 4]}
              mr={3}
              py={3}
              textAlign={["center", "left"]}
            >
              <Image src={logoBalmaceda} width={["200px"]} mt={[4, 5]} mb={4} />
              <Text fontSize={[24]} fontWeight="lighter" py={4} pr={[0, 3]}>
                {language === "es_MX"
                  ? ` ${t("collection.collection")} ${title}`
                  : ` ${title} ${t("collection.collection")}`}
              </Text>
              <Text
                fontSize={15}
                fontWeight="lighter"
                py={2}
                pr={[0, 3]}
                dangerouslySetInnerHTML={this.createMarkup(description)}
              />
            </Box>
            <Box
              width={[1, 1 / 2]}
              pr={[0, 2]}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                src={featuredImg}
                sx={{ width: "100%" }}
                onClick={this.onOpenImageModal}
              />
              <Modal
                open={openModalImage}
                onClose={this.onCloseImageModal}
                center
                styles={modalStyles}
              >
                <Image src={zoomImg} />
              </Modal>
            </Box>
          </Flex>
          {showContact ? (
            <Contact productName={name} />
          ) : (
            <Flex flexDirection={["column", "row"]} mx={[0, 2, 6]}>
              <Text
                textAlign="center"
                width={[1, 2 / 3, 3 / 4]}
                fontWeight="lighter"
                py={[0, 3]}
                mt={[0, 2]}
                mr={[0, 2, 0]}
              >
                {t("collection.customPieces")}
                {" "}
              </Text>
              <Button
                width={[1, 1 / 3, 1 / 4]}
                p={2}
                fontSize={15}
                my={3}
                onClick={this.onOpenContact}
              >
                {t("collection.contactUs")}
              </Button>
            </Flex>
          )}
        </Modal>
      </Item>
    )
  }
}

CollectionItem.propTypes = {
  thumbImg: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  featuredImg: PropTypes.string.isRequired,
  zoomImg: PropTypes.string.isRequired,
  language: PropTypes.string,
  t: PropTypes.func.isRequired,
  name: PropTypes.string,
}
export default withTranslation(CollectionItem)
